module.exports = __webpack_public_path__ + "img/thrilling-tales-of-dragon-slayers.305459e4.webp";